module.exports = __webpack_public_path__ + "static/img/yaoqingzhuanqian_bac.411d725.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yaoqingzhuanqian_bac.png
// module id = 3Mdv
// module chunks = 1